module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "col-xs-12 npd mainhead"
  }, [_c('section', {
    staticClass: "col-xs-12 topnav"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('router-link', {
    staticClass: "logo",
    attrs: {
      "to": {
        name: 'Inicio'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.theme_url + '/html/assets/img/logo.svg',
      "alt": ""
    }
  })]), _vm._v(" "), _c('nav', {
    staticClass: "menu"
  }, [_vm._m(0), _vm._v(" "), _c('ul', _vm._l((_vm.menus), function(menu) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": menu.url
      }
    }, [_vm._v(_vm._s(menu.title))])], 1)
  }))])], 1)])]), _vm._v(" "), _c('section', {
    staticClass: "col-xs-12 subnav"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('proximosprogramas'), _vm._v(" "), _c('buscador'), _vm._v(" "), _c('ul', {
    staticClass: "social"
  }, _vm._l((_vm.sm), function(value, key) {
    return _c('li', [_c('a', {
      attrs: {
        "href": value,
        "target": "_blank"
      }
    }, [_c('i', {
      class: 'fa ' + key
    })])])
  }))], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbut"
  }, [_c('span', {
    staticClass: "bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "bar"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05f79353"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/theme-header.vue
// module id = 115
// module chunks = 0